(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pranos-trust-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pranos-media-strip')) {
  customElements.define('pranos-media-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('.pranos-media__viewport');
      this.track = this.querySelector('.pranos-media__track');
      if (!this.viewport || !this.track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const viewport = this.viewport;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width:749px)');
      const original = this.track.firstElementChild;
      const clone = () => {
        const copy = original.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.dataset.nativeCopy = 'true';
        copy.querySelectorAll('a').forEach((link) => link.tabIndex = -1);
        return copy;
      };
      this.track.prepend(clone(), clone());
      this.track.append(clone());
      this.dataset.nativeScroll = 'true';
      this.group = original;
      this.ignoreScrollUntil = performance.now() + 100;
      viewport.scrollLeft = this.reducedMotion.matches ? 0 : original.getBoundingClientRect().width * 2;
      viewport.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      viewport.addEventListener('touchstart', () => {
        this.touching = true;
        this.suppressClickUntil = 0;
        this.stopMotion();
      }, { signal, passive: true });
      const endTouch = (event) => {
        if (!this.touching) return;
        this.touching = event.touches.length > 0;
        if (!this.touching) this.queueAuto(1000);
      };
      window.addEventListener('touchend', endTouch, { signal, passive: true });
      window.addEventListener('touchcancel', endTouch, { signal, passive: true });
      viewport.addEventListener('scroll', () => {
        if (this.frame != null || performance.now() < this.ignoreScrollUntil) return;
        this.queueAuto(1000);
      }, { signal, passive: true });
      viewport.addEventListener('wheel', () => {
        this.stopMotion();
        this.queueAuto(1000);
      }, { signal, passive: true });
      viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.stopMotion();
      }, { signal });
      viewport.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.queueAuto(1000);
      }, { signal });
      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.reducedMotion.matches) return;
        this.stopMotion();
        this.suppressClickUntil = 0;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, left: viewport.scrollLeft, samples: [{ x: event.clientX, time: event.timeStamp }] };
      }, { signal });
      window.addEventListener('pointermove', (event) => {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        if (!gesture.dragged) {
          if (Math.abs(dx) < 8) return;
          gesture.dragged = true;
          this.dataset.dragging = 'true';
          viewport.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        gesture.samples.push({ x: event.clientX, time: event.timeStamp });
        gesture.samples = gesture.samples.filter((sample) => event.timeStamp - sample.time <= 100);
        viewport.scrollLeft = gesture.left - dx;
      }, { signal });
      const endMouse = (event) => {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        this.gesture = null;
        delete this.dataset.dragging;
        if (viewport.hasPointerCapture(gesture.id)) viewport.releasePointerCapture(gesture.id);
        if (gesture.dragged) {
          this.suppressClickUntil = performance.now() + 500;
          const first = gesture.samples.find((sample) => event.timeStamp - sample.time <= 100);
          const elapsed = first && event.timeStamp - first.time;
          const velocity = elapsed > 0 ? (first.x - gesture.samples.at(-1).x) / elapsed : 0;
          if (event.type === 'pointerup' && Math.abs(velocity) > 0.08 && this.dataset.paused !== 'true') {
            this.startMouseCoast(Math.max(-2, Math.min(2, velocity)));
            return;
          }
        }
        this.queueAuto(1000);
      };
      window.addEventListener('pointerup', endMouse, { signal });
      window.addEventListener('pointercancel', endMouse, { signal });
      viewport.addEventListener('lostpointercapture', (event) => {
        if (event.target === viewport) endMouse(event);
      }, { signal });
      viewport.addEventListener('click', (event) => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { signal, capture: true });
      this.addEventListener('focusin', (event) => {
        if (event.target.matches('.pranos-media__logo:focus-visible')) this.stopMotion();
      }, { signal });
      this.addEventListener('focusout', () => this.queueAuto(1000), { signal });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.pranos-media__pause');
        if (!button || !this.contains(button)) return;
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        this.stopMotion();
        if (!paused) this.queueAuto(0);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.textContent = paused ? button.dataset.playText : button.dataset.pauseText;
      }, { signal });
      this.reducedMotion.addEventListener('change', () => {
        this.stopMotion();
        this.ignoreScrollUntil = performance.now() + 100;
        viewport.scrollLeft = this.reducedMotion.matches ? 0 : this.group.getBoundingClientRect().width * 2;
        this.queueAuto(1500);
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        this.stopMotion();
        if (!document.hidden) this.queueAuto(1000);
      }, { signal });
      if ('ResizeObserver' in window) {
        let previousWidth = viewport.getBoundingClientRect().width;
        this.resizeObserver = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width === previousWidth) return;
          previousWidth = entry.contentRect.width;
          this.stopMotion();
          this.queueAuto(1000);
        });
        this.resizeObserver.observe(viewport);
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.dataset.inView = String(entry.isIntersecting && entry.intersectionRatio >= 0.6);
          this.stopMotion();
          if (this.dataset.inView === 'true') {
            this.queueAuto(this.hasAppeared ? 1000 : 1500);
            this.hasAppeared = true;
          }
        }, { threshold: [0, 0.6] });
        this.observer.observe(viewport);
      } else {
        this.dataset.inView = 'true';
        this.queueAuto(1500);
      }
    }
    canAuto() {
      return this.dataset.inView === 'true' && this.dataset.paused !== 'true' && !this.reducedMotion.matches && !document.hidden && !this.touching && !this.gesture && !this.hovered && !this.querySelector('.pranos-media__logo:focus-visible');
    }
    queueAuto(delay) {
      clearTimeout(this.resumeTimer);
      if (this.frame != null || !this.canAuto()) return;
      this.resumeTimer = setTimeout(() => {
        if (!this.canAuto()) return;
        const width = this.group.getBoundingClientRect().width;
        if (!width) return;
        const duration = this.mobile.matches ? 25000 : 42000;
        let position = this.viewport.scrollLeft;
        let previous = performance.now();
        const start = previous;
        const tick = (now) => {
          if (!this.canAuto()) { this.stopMotion(); return; }
          position += width / duration * Math.min(now - previous, 50) * Math.min((now - start) / 500, 1);
          previous = now;
          position = width * 2 + ((position % width) + width) % width;
          this.viewport.scrollLeft = position;
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }, delay);
    }
    startMouseCoast(velocity) {
      const start = performance.now();
      const position = this.viewport.scrollLeft;
      const tick = (now) => {
        if (this.dataset.paused === 'true' || this.dataset.inView !== 'true' || this.reducedMotion.matches || this.touching) { this.stopMotion(); return; }
        const elapsed = Math.min(now - start, 1400);
        this.viewport.scrollLeft = position + velocity * 280 * (1 - Math.exp(-elapsed / 280));
        if (elapsed < 1400) this.frame = requestAnimationFrame(tick);
        else { this.stopMotion(); this.queueAuto(1000); }
      };
      this.frame = requestAnimationFrame(tick);
    }
    stopMotion() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      clearTimeout(this.resumeTimer);
    }
    disconnectedCallback() {
      this.stopMotion();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.gesture = null;
      this.touching = false;
      this.hovered = false;
      this.hasAppeared = false;
      this.querySelectorAll('[data-native-copy]').forEach((copy) => copy.remove());
      delete this.dataset.nativeScroll;
      delete this.dataset.dragging;
      delete this.dataset.inView;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
